<template>
  <hic-dialog title="病历详情" :close-on-click-modal="false" :visible="visible" append-to-body @close="cancel" width="54rem" top="4vh" hide-footer >
    <el-row style="min-height: 40rem">
      <emr-info-panel :op-no="opNo"  />
    </el-row>
  </hic-dialog>
</template>
<script>
  export default {
    name: "hic-emr-info-dialog",
    props: {
      visible: Boolean,
      opNo: String,
    },
    components: {
      "emr-info-panel": () => import("./emrInfoPanel"),
    },
    methods: {
      cancel() {
        this.$emit("update:visible", false);
      },
    }
  };
</script>
